import { useSetAtom } from 'jotai';

import { TabItem, Tabs } from '@cfa/react-components';

import { COUNTRIES } from '@/utils/document-utils/countries';

import { ContentReference } from '@/_generated/api-clients/xp';
import { setChosenCountryTabAtom } from '@/atoms/document-transient';

interface ChooseDocumentCountryTabsProps {
  activeCountryTab?: string;
  countryHasResource: string[];
}

const ChooseDocumentCountryTabs = ({
  activeCountryTab,
  countryHasResource,
}: ChooseDocumentCountryTabsProps) => {
  const setChosenCountryTab = useSetAtom(setChosenCountryTabAtom);
  const activeTabKey = activeCountryTab ?? countryHasResource[0] ?? '';

  const handleChange = (tab: string) => {
    setChosenCountryTab(tab as ContentReference['country']);
  };

  if (countryHasResource.length <= 1) {
    return null;
  }

  return (
    <div className="shadow-elevation-6 -mx-8 mb-8 w-[calc(100%+64px)]">
      <Tabs
        activeItemKey={activeTabKey}
        color="secondary"
        onChange={handleChange}
        className="[&_.cfa-tabs-list]:border-grayscale-gray2! [&_.cfa-horizontal-slider]:w-[92px]! [&_.cfa-tabs-list]:box-border! [&_.cfa-tabs-list]:border-b! [&_.cfa-tabs-list]:px-8!"
      >
        {COUNTRIES.filter(({ id }) => countryHasResource.includes(id)).map(
          ({ id, label }) => (
            <TabItem
              key={id}
              itemKey={id}
              className="[&>button]:mt-1.5! [&>button]:mb-5! [&>button]:px-8!"
            >
              {label ?? id}
            </TabItem>
          ),
        )}
      </Tabs>
    </div>
  );
};

export default ChooseDocumentCountryTabs;
